import { render, staticRenderFns } from "./MInplayDetail.vue?vue&type=template&id=9510a106&scoped=true"
import script from "./MInplayDetail.vue?vue&type=script&lang=js"
export * from "./MInplayDetail.vue?vue&type=script&lang=js"
import style0 from "./MInplayDetail.vue?vue&type=style&index=0&id=9510a106&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9510a106",
  null
  
)

export default component.exports